import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import ReactDOM from 'react-dom';
import { SelectType, ListaProps } from '../types';
import { Option, PortalList } from '../styles';

export interface ListaRef {
  element: HTMLUListElement | null;
}

const Lista = forwardRef<ListaRef, ListaProps>(
  ({ options, inputRef, setSelected, setIsOpen }, ref) => {
    const listRef = useRef<HTMLUListElement>(null);
    const [coords, setCoords] = useState({ top: 0, left: 0, width: 320 });

    useImperativeHandle(ref, () => ({
      element: listRef.current,
    }));

    const handleClick = (option: SelectType) => {
      setSelected(option);
      setIsOpen(false);
    };

    const handleKeyPress = (
      event: React.KeyboardEvent<HTMLLIElement>,
      option: SelectType,
    ) => {
      if (event.key === 'Enter') handleClick(option);
    };

    useEffect(() => {
      if (inputRef.current) {
        const rect = inputRef.current.getBoundingClientRect();
        setCoords({
          top: rect.bottom + window.scrollY,
          left: rect.left + window.scrollX,
          width: 320,
        });
      }
    }, [inputRef.current, options.length]);

    return ReactDOM.createPortal(
      <PortalList
        ref={listRef}
        style={{
          position: 'absolute',
          top: coords.top,
          left: coords.left,
          width: coords.width,
          zIndex: 9999,
        }}
      >
        {options.length > 0 ? (
          options.map((option) => (
            <Option
              key={option.value}
              tabIndex={0}
              onClick={() => handleClick(option)}
              onKeyDown={(e) => handleKeyPress(e, option)}
            >
              {option.label}
            </Option>
          ))
        ) : (
          <Option className="not-found">Nenhuma opção encontrada</Option>
        )}
      </PortalList>,
      document.body,
    );
  },
);

export default Lista;
